/**
 * Freedom 250 / July 4 — product card one-time add to cart (primary CTA).
 */
(function () {
  'use strict';

  if (window.__rncJuly4CartInit) return;
  window.__rncJuly4CartInit = true;

  var BUNDLE_HANDLES = [
    'apricot-seed-daily',
    'apricot-seed-pro',
    'b17-prevention-bundle',
    'b17-pro',
    'apricot-luxe-beauty',
  ];

  function getApi() {
    return window.RNC_BUNDLE_GIFTS;
  }

  function isBundleHandle(handle) {
    return BUNDLE_HANDLES.indexOf(handle) >= 0;
  }

  function pushCta(placement, handle) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'july4_cta_click',
        placement: placement,
        product_handle: handle || undefined,
      });
    } catch (e) {}
  }

  function runButtonAdd(btn, promise, handle, placement) {
    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    promise
      .then(function () {
        pushCta(placement, handle);
        btn.textContent = 'Added →';
        setTimeout(function () {
          btn.textContent = orig;
          btn.disabled = false;
        }, 2500);
      })
      .catch(function (err) {
        var msg = (err && err.message) || '';
        if (/sold out|unavailable|not available/i.test(msg)) {
          btn.textContent = 'Sold out. View product';
          btn.disabled = false;
          setTimeout(function () {
            window.location.href = '/products/' + handle;
          }, 1200);
          return;
        }
        btn.textContent = 'Try again';
        btn.disabled = false;
        setTimeout(function () {
          btn.textContent = orig;
        }, 2000);
      });
  }

  function addOneTimeToCart(variantId, handle, openDrawer) {
    var api = getApi();

    if (api && isBundleHandle(handle) && typeof api.addBundleToCart === 'function') {
      return api.addBundleToCart({
        variantId: variantId,
        bundleHandle: handle,
        isSubscribe: false,
        openDrawer: openDrawer !== false,
      });
    }

    if (api && typeof api.addSubscribeLineToCart === 'function') {
      return api.addSubscribeLineToCart({
        variantId: variantId,
        openDrawer: openDrawer !== false,
      });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          throw new Error((data && data.description) || 'Could not add to cart');
        }
        if (api && typeof api.openCartDrawer === 'function') {
          api.openCartDrawer();
        }
        return data;
      });
    });
  }

  document.addEventListener('click', function (e) {
    var onceBtn = e.target.closest('[data-july4-onetime-atc]');
    if (onceBtn) {
      e.preventDefault();
      var card = onceBtn.closest('.rnc-july4-product-card');
      if (!card) return;

      var variantId = card.getAttribute('data-variant-id') || '';
      var handle = card.getAttribute('data-handle') || '';

      if (!variantId) {
        window.location.href = '/products/' + handle;
        return;
      }

      runButtonAdd(onceBtn, addOneTimeToCart(variantId, handle, true), handle, 'onetime-atc');
    }
  });

  document.querySelectorAll('[data-july4-cta]').forEach(function (el) {
    if (el.closest('.rnc-july4-products')) {
      el.addEventListener('click', function () {
        pushCta(el.getAttribute('data-july4-cta'));
      });
    }
  });
})();
